"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var ProgressBarWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    height: 5px;\n    background-color: ", ";\n    border-radius: 4px;\n"], ["\n    width: ", ";\n    height: 5px;\n    background-color: ", ";\n    border-radius: 4px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? '120px' : '218px';
}, function (_a) {
  var theme = _a.theme;
  return theme.colorVariations.greyscale.alpha40;
});
exports.ProgressContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n    margin: 0 auto;\n    padding: 5px;\n    ", "\n"], ["\n    flex-direction: row;\n    align-items: center;\n    margin: 0 auto;\n    padding: 5px;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? 'position: absolute; top: 32px; bottom: auto; left: 6%; right: 0px; width: 120px;' : '';
});
var Tracker = styled_components_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "%;\n    height: 100%;\n    border-radius: 4px;\n    background-color: ", ";\n"], ["\n    width: ", "%;\n    height: 100%;\n    border-radius: 4px;\n    background-color: ", ";\n"])), function (_a) {
  var value = _a.value;
  return value > 100 ? 100 : value;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.main.purple;
});
exports.ProgressIndicator = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", "\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 14px;\n    margin: 5px;\n    ", "\n"], ["\n    color: ", "\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 14px;\n    margin: 5px;\n    ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.main.purple;
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? 'display: none;' : '';
});

exports.ProgressBar = function (_a) {
  var value = _a.value,
      backgroundColor = _a.backgroundColor,
      activeBreakpoint = _a.activeBreakpoint;
  return react_1.default.createElement(ProgressBarWrapper, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(Tracker, {
    value: value,
    backgroundColor: backgroundColor
  }));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;